import React, { useContext } from 'react';
import TabsController, { Tab } from './tabsController';

export const TabsContext = React.createContext<TabsController | null>(null);

export function defaultOnRequestClose() {
  return new Promise((resolve) => {
    resolve(true);
  });
}

export function useTabsContext() {
  return React.useContext(TabsContext);
}

export function useTabsController() {
  return useContext(TabsContext);
}

export const CurrentTabContext = React.createContext<Tab | null>(null);

export function useCurrentTab() {
  return React.useContext(CurrentTabContext);
}
